module.exports = __webpack_public_path__ + "static/media/tw-direct.f6ba79e8.svg";